import { fetchAuthSession, JWT } from "aws-amplify/auth";
import { makeAutoObservable, runInAction } from "mobx";

export class AuthStore {
  idToken?: JWT;
  isAuthenticated = false;
  isSuperAdmin = false;
  userEmail?: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  async onSignIn() {
    const user = await fetchAuthSession();
    const idToken = user.tokens?.idToken;

    if (idToken) {
      runInAction(() => {
        this.idToken = idToken;
        this.isSuperAdmin = idToken.payload["custom:role"] === "SuperAdmin";
        this.userEmail = idToken.payload["email"]?.toString();
        this.isAuthenticated = true;
      });
    }
  }

  onSignOut() {
    runInAction(() => {
      this.idToken = undefined;
      this.isAuthenticated = false;
      this.userEmail = undefined;
      this.isSuperAdmin = false;
    });
  }
}
